module.exports = __webpack_public_path__ + "static/media/invoice.bcf49768.jpg";